import React from 'react';
import { Global } from '@emotion/react';
import { cssReset } from 'ui_system/token_auth/styles_root';
import { Logo } from './logo';
import { Container, H1, BareHR, BodyText, RedLink } from './PrivacyStyles';

const PrivacyVerificationDuplicate = () => (
  <React.Fragment>
    <Global styles={cssReset({})} />
    <Logo />
    <BareHR />
    <Container>
      <H1>Request already submitted</H1>
      <BodyText>
        It appears this request has already been submitted. Our team will review
        your request and follow up with you via email.
        <br />
        <br />
        If you believe you have landed on this page in error, please{' '}
        <RedLink href="/ccpa">submit a new request</RedLink>.
      </BodyText>
    </Container>
  </React.Fragment>
);

export default PrivacyVerificationDuplicate;
